import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/store/user';

import HomeView from "../views/Home/HomeView.vue";

import LoginView from "../views/Login/LoginView.vue";
import ConfigsView from "../views/Configs/ConfigsView.vue";

import AppNotificationsListView from "../views/AppNotifications/AppNotificationsListView.vue";
import AppNotificationReadingView from "../views/AppNotifications/AppNotificationReadingView";

import PatientsListView from "../views/Patients/PatientsListView.vue";
import PatientCrudView from "../views/Patients/PatientCrudView.vue";
import PatientReportsListView from "../views/Patients/PatientReportsListView.vue"
import PatientReportReadingView from "../views/Patients/PatientReportReadingView.vue";
import PatientIndicatorsReadingView from "../views/Patients/PatientIndicatorsReadingView.vue";
import PatientSchedulingsListView from "../views/Patients/PatientSchedulingsListView.vue";

import PatientListMedicalRecords from "../views/Patients/PatientListMedicalRecords.vue";
import MedicalRecordCrud from "../views/Patients/MedicalRecordCrudView.vue";

import ReportsListView from "../views/Reports/ReportsListView.vue";
import ReportCrudView from "../views/Reports/ReportCrudView.vue";

import SchedulingsListView from "../views/Schedulings/SchedulingsListView.vue";
import SchedulingCrudView from "../views/Schedulings/SchedulingCrudView.vue";
import MySchedulingsListView from "../views/Schedulings/MySchedulingsListView.vue";

import PrivacyView  from "../views/Privacy/PrivacyView.vue";
import TermsView from "../views/Terms/TermsView.vue";



const getUserType = () => {
  const userStore = useUserStore();
  return userStore.getUser.type;
}

const isAPatient = (to, from, next) => {
  const userStore = useUserStore();  
  if (getUserType() != "Patient") {
    userStore.signOut();
    next("/login");  
  }
  else {
    next();
  } 
};

const isAProfessional = (to, from, next) => {
  const userStore = useUserStore();
  if (getUserType() != "Professional") {
    userStore.signOut();
    next("/login");
  }
  else {
    next();
  }
}

const homeForPatient = (to, form, next) => {
  if (getUserType() != "Professional") {    
    next("/reports");
  }
  else {
    next();
  }
}

const routes = [
  { path: '/login', name: 'Login', component: LoginView },
  { path: '/login/:resetId', name: 'LoginReset', component: LoginView, props: true },  
  { path: '/', name: 'Home', component: HomeView, beforeEnter: homeForPatient, meta: { requiresAuth: true } },
  { path: '/AppNotifications', name: 'ListaDeNotificacoes', component: AppNotificationsListView, meta: { requiresAuth: true } },
  { path: '/AppNotifications/:appNotificationId', name:'LeituraDeNotificacao', component: AppNotificationReadingView, props:true },        
  { path: '/reports', name: 'ListaDeRelatos', component: ReportsListView, beforeEnter: isAPatient, meta: { requiresAuth: true } },
  { path: '/myschedulings', name: 'ListaDeMeusAgendamentos', component: MySchedulingsListView, beforeEnter: isAPatient, meta: { requiresAuth: true } },
  { path: '/reports/:reportId', name:'CadastroDeRelato', component: ReportCrudView, props: true },      
  { path: '/patients', name: 'ListaDePacientes', component: PatientsListView, beforeEnter: isAProfessional, meta: { requiresAuth: true } },    
  { path: '/patients/:patientId', name:'CadastroDePaciente', component: PatientCrudView, props:true },
  { path: '/patients/:patientId/indicators', name:'IndicadoresDeHumorDoPaciente', component: PatientIndicatorsReadingView, props:true },
  { path: '/patients/:patientId/reports', name:'ListaDeRelatosDoPaciente', component: PatientReportsListView, props:true },
  { path: '/patients/:patientId/reports/:reportId', name:'LeituraDeRelatoDoPaciente', component: PatientReportReadingView, props:true },
  { path: '/patients/:patientId/schedulings', name:'ListaDeAgendamentosDoPaciente', component: PatientSchedulingsListView, props:true },
  { path: '/patients/:patientId/records', name:'ListaDeProntuarios', component: PatientListMedicalRecords, props:true },
  { path: '/patients/:patientId/records/create', name:'CriacaoDeProntuario', component: MedicalRecordCrud, props:true },
  { path: '/patients/:patientId/records/:recordId', name:'AlteracaoDeProntuario', component: MedicalRecordCrud, props:true },
  { path: '/schedulings', name: 'ListaDeAgendamentos', beforeEnter: isAProfessional, component: SchedulingsListView, meta: { requiresAuth: true } },
  { path: '/schedulings/:schedulingId', name:'CadastroDeAgendamento', component: SchedulingCrudView, props:true },   
  { path: '/configs', name: 'Configurações', component: ConfigsView, meta: { requiresAuth: true } },
  { path: '/privacy', name: 'Declaração de privacidade', component: PrivacyView },
  { path: '/terms', name: 'Termos de uso', component: TermsView}        
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore();
  const loggedIn = userStore.user.loggedIn;
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {      
    next("/login");
  } else {    
    next();
  }
})




export default router
